import React, { useEffect, useState } from "react";
import { fetchRestaurantCms, getCmsDescriptionHtml } from "../utils/cms";

const fallbackTermsDescription =
  'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC.';

function TermsAndCondition() {
  const [termsCondition, setTermsCondition] = useState(null);

  useEffect(() => {
    const getTermsCondition = async () => {
      try {
        const result = await fetchRestaurantCms();
        setTermsCondition(result?.data?.terms_condition);
      } catch (error) {
        console.error('Error fetching terms condition CMS:', error);
      }
    };

    getTermsCondition();
  }, []);

  const descriptionHtml =
    getCmsDescriptionHtml(termsCondition) || `<p>${fallbackTermsDescription}</p>`;

  return (
    <>
      <section className="my-8 md:my-16 md:px-10 2xl:px-20 overflow-hidden 2xl:py-10 h-full">
        <div className="max-w-screen-2xl text-white mx-auto px-6">
          <div className='fancy-heading [&_h2]:text-[24px] md:[&_h2]:text-[36px] 2xl:[&_h2]:text-[45px] text-white [&_h2]:font-PxBold text-center mb-8 md:mb-10 flex flex-col items-center'>
            <h2 className='flex items-center gap-x-3 before:relative before:w-8 md:before:w-32 before:h-0.5 before:bg-gradient-to-l before:from-[#28CDFA] before:via-[#29292A8C] before:to-[#29292A66] after:content-[""] after:w-8 md:after:w-32 after:h-0.5 after:bg-gradient-to-l after:from-[#29292A66] after:via-[#29292A8C] after:to-[#28CDFA]'>{termsCondition?.title || 'Terms & Condition'}</h2>
          </div>
          <div
            className="[&_*]:mb-4 font-PoppinsL text-sm md:text-base 2xl:text-lg leading-normal content"
            dangerouslySetInnerHTML={{ __html: descriptionHtml }}
          />
        </div>
      </section>
    </>
  );
}

export default TermsAndCondition;
